import { useState, useEffect } from "react";
import Cookies from "js-cookie";

function NewTestComponent() {
  return <p>OOPS! Need a rebuild.</p>;
}

export default NewTestComponent;
